<template>
  <div class="border-top py-2">
    <div class="product-wrap pt-3 pb-2 pr-3 d-flex">
      <div v-for="(item, index) in productDisplayList" :key="index" class="">
        <div class="image-card mr-2 p-2 pointer">
          <div class="position-relative picture-text pic-table product-image">
            <div
              v-if="item.imageUrl"
              class="square-box b-contain pic-box"
              v-bind:style="{
                'background-image': 'url(' + item.imageUrl + ')',
              }"
            ></div>
          </div>
          <div class="line-clamp my-2 f-size-14">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
    dataLength: {
      required: true,
      type: Number,
    },
    channelList: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      productFilter: {
        Categories: [],
        pageNo: 1,
        perPage: 9,
        productIdList: [],
        searech: "",
      },
      productDisplayList: [],
    };
  },
  computed: {
    channelType: function () {
      return this.channelList.find((el) => {
        return el.id == this.data.channelTypeId;
      });
    },
  },
  mounted: async function () {
    this.$nextTick(async () => {
      if (this.data.content.Product.length > 0) {
        this.data.content.Product.sort(function (a, b) {
          return a.SortOrder - b.SortOrder;
        });
        this.productFilter.productIdList = this.data.content.Product.map(
          (el) => el.ProductId
        );
        await this.getProductSelectedList();
      }
    });
  },
  methods: {
    getProductSelectedList: async function () {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/product/list`, this.productFilter)
        .then((data) => {
          if (data.result == 1) {
            this.productDisplayList = data.detail.dataList;
            this.data.content.Product.forEach((element, index) => {
              this.productDisplayList.forEach((element2) => {
                if (element.ProductId == element2.id) {
                  element2.SortOrder = index;
                }
              });
            });
            this.productDisplayList.sort(function (a, b) {
              return a.SortOrder - b.SortOrder;
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.border-radius-5 {
  border-radius: 5px;
}
.break-white-space {
  white-space: break-spaces;
}
.product-wrap {
  width: calc(100%);
  overflow: hidden;
  overflow-x: auto;
  //   background-color: white;
}
.image-card {
  width: 150px;
  background-color: white;
  min-height: 200px;
  border-radius: 8px;
  border: 2px dashed #bebebe;
}
.line-clamp {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.f-size-14 {
  font-size: 14px;
}
.product-image {
  height: 100px;
}
</style>
